module.exports = __webpack_public_path__ + "img/loveInvitation.5fda3615.png";